import "bootstrap/dist/css/bootstrap.min.css"
import { wrapper } from "./src/contexts/global_state"
export const wrapRootElement = wrapper
